import { render, staticRenderFns } from "./shiplocation.vue?vue&type=template&id=da47e3a6&scoped=true&"
import script from "./shiplocation.vue?vue&type=script&lang=js&"
export * from "./shiplocation.vue?vue&type=script&lang=js&"
import style0 from "./shiplocation.vue?vue&type=style&index=0&id=da47e3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da47e3a6",
  null
  
)

export default component.exports